module.exports = __webpack_public_path__ + "media/images/hero/hero-bg7-f30f997b61eaa205c2d145035d65ef14.jpg";